import { t, type I18nLocale } from '@ardoq/i18n';

type NoEditAccessDoqiLabels = {
  title: string;
  message: string;
  buttonLabel: string;
};

export const getNoEditAccessDoqiLabels = (
  i18nLocale: I18nLocale
): NoEditAccessDoqiLabels => ({
  title: t(
    i18nLocale,
    'dashboard:builder.noEditAccess.title',
    "You can't edit this Dashboard"
  ),
  message: t(
    i18nLocale,
    'dashboard:builder.noEditAccess.message',
    "You don't have permission to edit this Dashboard. Go to Dashboard overview to access a different Dashboard."
  ),
  buttonLabel: t(
    i18nLocale,
    'dashboard:builder.noEditAccess.buttonLabel',
    'Dashboard overview'
  ),
});

export const METRICS_DSB_ID = '0000000000000000000001C5';

export const LABEL_FIELD_MISSING =
  'A label is required to group your data and save your chart';

export const VALUE_FIELD_MISSING =
  'You must select a value to save your chart when using the sum aggregation';
